import { render, staticRenderFns } from "./PeriodsExpansionPanels.vue?vue&type=template&id=d60ec0ae&"
import script from "./PeriodsExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./PeriodsExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsExpansionPanels.vue?vue&type=style&index=0&id=d60ec0ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports